import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import PreviewPage from './components/PreviewPage';
import AdminPreviewPage from './components/AdminPreviewPage';
import ImportUrlsPage from './components/ImportUrlsPage';
import WriteArticlePage from './components/WriteArticlePage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';

function AppRouter() {
  return (
    <Router>
      <Routes>
        {/* Public reader preview — no sidebar */}
        <Route path="/preview" element={<PreviewPage />} />

        {/* All admin pages share the sidebar layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <App />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-preview"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminPreviewPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/import"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ImportUrlsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/write"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <WriteArticlePage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default AppRouter;
